import { useOfferCardContext } from '../context/offerCardContext';

export const useOffer = () => {
  const { offer } = useOfferCardContext();

  return offer;
};
